import {
    BDX_CURRENCY_TYPES,
    BDX_ACCOUNT_TYPES,
    BILLING_LIMOSS,
    BILLING_MARKET,
    JURISDICTION_TYPES
} from '@constants'

const STATUS_OPTIONS = [
    { text: 'Active',   value: 'Active'   },
    { text: 'Inactive', value: 'Inactive' }
]

const BILLING_TYPE_OPTIONS = [
    { text: BILLING_MARKET, value: BILLING_MARKET },
    { text: BILLING_LIMOSS, value: BILLING_LIMOSS }
]

const BILLING_STATUS_COLUMN = {
    key:        'billing_status',
    label:      'Billing Status',
    sortable:   true,
    searchable: true,
    options:    STATUS_OPTIONS,
    width:      175,
}

const BILLING_TYPE_COLUMN = {
    key:        'billing_type',
    label:      'Billing Type',
    sortable:   true,
    searchable: true,
    options:    BILLING_TYPE_OPTIONS,
    width:      160,
}

const REC_STATUS_COLUMN = {
    key:        'rec_status',
    label:      'Rec Status',
    sortable:   true,
    searchable: true,
    options:    STATUS_OPTIONS,
    width:      160,
}

export const getBDXManagementTableColumns = (isSuperUser = false) => [
    {
        key:        'bdx_status',
        label:      'BDX Status',
        sortable:   true,
        searchable: true,
        options:    STATUS_OPTIONS,
        width:      160,
    },
    // billing columns only visible to superusers
    ...(isSuperUser ? [BILLING_STATUS_COLUMN, BILLING_TYPE_COLUMN] : []),
    // rec_status column only visible to superusers
    ...(isSuperUser ? [REC_STATUS_COLUMN] : []),
    {
        key:        'fcp_status',
        label:      'FCP',
        sortable:   true,
        searchable: true,
        options:    STATUS_OPTIONS,
        width:      100,
    },
    {
        key:      'created_on',
        label:    'First Match Date',
        sortable: true,
        datePicker: { range: true },
        width:    200,
    },
    {
        key:        'last_report_date',
        label:      'Last Upload Date',
        sortable:   true,
        searchable: true,
        datePicker: { range: true },
        width:      230,
    },
    {
        key:        'umr_rc_cc_sn',
        label:      'LimeIQ Key',
        sortable:   true,
        searchable: true,
        width:      230,
    },
    {
        key:        'umr',
        label:      'UMR',
        sortable:   true,
        searchable: true,
        width:      175,
    },
    {
        key:        'risk_code',
        label:      'Risk Code',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        key:        'cat_code',
        label:      'Catastrophe Code',
        sortable:   true,
        searchable: true,
        width:      250,
    },
    {
        key:        'section_no',
        label:      'Section Number',
        sortable:   true,
        searchable: true,
        width:      250,
    },
    {
        key:        'tpa',
        label:      'TPA',
        sortable:   true,
        searchable: true,
        width:      150,
    },
    {
        key:        'underwriter_lead',
        label:      'UW Lead',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        key:        'underwriter_followers',
        label:      'UW Followers',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        // Read-only here: syndicate detail is captured only by the Slip
        // Share import. Not sortable/searchable - there is no backing
        // column to sort or search server-side, only a nested list per row.
        key:        'lead_syndicate',
        // Singular deliberately: a key has exactly one lead syndicate, and the
        // heading is what tells the reader that. The follow column beside it is
        // the plural case.
        label:      'Lead syndicate number',
        sortable:   false,
        searchable: false,
        width:      170,
    },
    {
        key:        'follower_syndicates',
        label:      'Follow syndicate number',
        sortable:   false,
        searchable: false,
        width:      190,
    },
    {
        key:        'coverholder',
        label:      'Coverholder',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        key:        'broker',
        label:      'Broker',
        sortable:   true,
        searchable: true,
        width:      150,
    },
    {
        key:        'ucr',
        label:      'UCR',
        sortable:   true,
        searchable: true,
        width:      150,
    },
    {
        key:        'account_type',
        label:      'Account Type',
        sortable:   true,
        searchable: true,
        options:    BDX_ACCOUNT_TYPES,
        width:      200,
    },
    {
        key:        'account_code',
        label:      'Account Code',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        key:        'account_name',
        label:      'Account Name',
        sortable:   true,
        searchable: true,
        width:      200,
    },
    {
        key:        'currency_type',
        label:      'Currency Type',
        sortable:   true,
        searchable: true,
        options:    BDX_CURRENCY_TYPES,
        width:      200,
    },
    {
        key:        'jurisdiction',
        label:      'Jurisdiction',
        sortable:   true,
        searchable: true,
        options:    JURISDICTION_TYPES,
        width:      200,
    }
]